import type { TFunction } from "i18next";
import type { GridColDef } from "src/components/DataGrid/DataGrid.tsx";
import placeholderImageSrc from "src/assets/illustrations/placeholder_image.svg";
import type { ProductRowResource } from "src/framework/listV2/types.ts";
import { formatPrice, formatWeight, toFixedWithoutZeros } from "@exonn/utils";
import { StatusCell } from "src/admin/lists/product/components/StatusCell.tsx";
import { ResourceEnum } from "src/constants/constants.ts";
import { TextFilterModeEnum } from "@exonn/js-sdk";

export const getColumns = ({
  t,
}: {
  t: TFunction;
}): GridColDef<ProductRowResource>[] => [
  {
    field: "image",
    type: "string",
    width: 70,
    headerName: t("table.columns.image"),
    filterable: false,
    resizable: false,
    sortable: false,
    renderHeaderFilter: () => null,
    renderCell: ({ row }) => {
      const src =
        Object.values(row.images)[0]?.preview_url || placeholderImageSrc;
      return (
        <div
          css={{
            height: "100%",
            width: "100%",
            display: "grid",
            placeContent: "center",
          }}
        >
          <img src={src} css={{ width: 50, height: "auto" }} alt="" />
        </div>
      );
    },
  },
  {
    field: "id",
    headerName: "ID",
    type: "string",
    width: 200,
  },

  {
    field: "title",
    headerName: t("table.columns.title"),
    backendFilterName: "deep_title",
    type: "string",
    width: 400,
  },
  {
    field: "short_description",
    type: "string",
    backendFilterName: "deep_short_description",
    headerName: t("table.columns.short_description"),
    width: 400,
  },
  {
    field: "status",
    width: 140,
    type: "singleSelect",
    headerName: t("table.columns.status"),
    headerFilterSelectProps: {
      options: {
        resource: ResourceEnum.Product,
        field: "status",
      },
    },
    align: "center",
    renderCell: StatusCell,
  },
  {
    field: "sku",
    type: "string",
    headerName: t("table.columns.sku"),
    backendFilterName: "deep_sku",
    defaultFilterOperator: TextFilterModeEnum.Exact,
  },
  {
    field: "unit_quantity",
    backendFilterName: "deep_unit_quantity",
    type: "number",
    align: "right",
    valueFormatter: (value, row) => toFixedWithoutZeros(+row.unit_quantity, 6),
    headerName: t("table.columns.unit_quantity"),
  },
  {
    field: "weight",
    backendFilterName: "deep_weight",
    type: "number",
    align: "right",
    valueFormatter: (value, row) => formatWeight(+row.weight),
    headerName: t("table.columns.weight"),
  },
  {
    field: "price",
    valueFormatter: (value, row) => formatPrice(+row.price),
    type: "number", // number
    align: "right",
    headerName: t("table.columns.price"),
    backendFilterName: "deep_price",
  },
];
